"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.string.match");

require("core-js/modules/es.string.replace");

require("core-js/modules/web.dom-collections.for-each");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _day2 = _interopRequireDefault(require("@zz-common/zz-utils/lib/day"));

var date = (0, _day2.default)().format('YYYY-MM-DD');

var _default = function _default(err) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var limitErrorCnt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 10;
  var client = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '未知';
  var Cookie = arguments.length > 5 ? arguments[5] : undefined;
  var Sentry = arguments.length > 6 ? arguments[6] : undefined;

  try {
    var errorCnt = {};
    var userId = Cookie.get('uid') || Cookie.get('sso_uid') || 'nofound';

    if (typeof sessionStorage !== 'undefined') {
      errorCnt = sessionStorage.getItem("zz_sentry_errorcnt_".concat(userId)) ? JSON.parse(sessionStorage.getItem("zz_sentry_errorcnt_".concat(userId))) : {};
    }

    var errObj = null;

    if (err instanceof Error) {
      errObj = err;
    } else if (err instanceof Object) {
      if (err.respMsg || err.errorMsg || err.errMsg || err.respData || err.respCode) {
        errObj = new Error(err.respMsg || err.errorMsg || err.errMsg || '网络异常');
      } else {
        errObj = new Error(JSON.stringify(err));
      }
    } else if (typeof err === 'string') {
      errObj = new Error(err);
    }

    var errorType = type;
    var isSendEmail = 0;

    if (!errorCnt[type]) {
      errorCnt[type] = 0;
    } // 获取错误类型，并且判断是否发送邮件


    switch (type) {
      case 1:
        errorType = '组件级错误';
        break;

      case 2:
        errorType = '页面级错误';
        isSendEmail = 1;
        break;

      case 3:
        errorType = '接口错误'; // 接口错误时，状态码大于10001不发邮件
        // eslint-disable-next-line no-case-declarations

        var tags = opts.tags || {};

        if (tags.respCode && tags.respCode <= 10000 && tags.respCode !== 0) {
          isSendEmail = 1;
        }

        break;

      case 4:
        errorType = '服务器错误';
        break;

      case 5:
        errorType = '请求失败';
        break;

      case 6:
        errorType = '请求未知错误';
        break;

      case 7:
        errorType = 'promise没有设置catch';
        break;

      case 8:
        errorType = '提示类信息';
        break;

      default:
        errorType = '其他';
        break;
    } // 除了promise错误，页面错误，接口错误以外的其他错误，同一用户只要超过3次就发送邮件


    if ([2, 3, 7].indexOf(type) < 0) {
      ++errorCnt[type];
      var limit = (0, _typeof2.default)(limitErrorCnt) === 'object' ? limitErrorCnt[type] || 10 : limitErrorCnt;

      if (errorCnt[type] % limit === 0) {
        isSendEmail = 1;
      } else {
        isSendEmail = 0;
      }

      if (typeof sessionStorage !== 'undefined') {
        sessionStorage.setItem("zz_sentry_errorcnt_".concat(userId), JSON.stringify(errorCnt));
      }
    } // tag信息，辅助快速定位错误


    var t = Cookie.get('zz_t') || Cookie.get('t') || '';
    var ua = navigator.userAgent.match(/zzVersion\/(.*?)\s/) ? navigator.userAgent.match(/zzVersion\/(.*?)\s/)[1] : '';
    var version = Cookie.get('v') || ua;
    var tagsDefault = {
      errorType: errorType,
      client: client,
      errInfo: errObj && errObj.message,
      env: process.env.NODE_ENV || '未知',
      isSendEmail: isSendEmail,
      t: t,
      version: version,
      tVersion: "".concat(t, " ").concat(version),
      uid: userId,
      tel: Cookie.get('tel') || ''
    };

    if (typeof location !== 'undefined') {
      tagsDefault.route = location.hash && location.hash.replace(/(#)([^\?]*)(\?.*)*/g, '$2') || location.href;
    }

    if (client === '小程序') {
      // 主动发送错误
      Sentry.captureException(errObj, {
        message: errObj && errObj.message,
        tags: Object.assign(tagsDefault, opts.tags || {}),
        extra: Object.assign({
          cookie: Cookie.get()
        }, opts.extra || {}),
        fingerprint: [process.env.NODE_ENV, errorType, errObj && errObj.message]
      });
    } else {
      // 主动发送错误
      Sentry.withScope(function (scope) {
        scope.setTags(Object.assign(tagsDefault, opts.tags || {}));
        var extras = Object.assign({
          cookie: Cookie.get(),
          UA: navigator.userAgent
        }, opts.extra || {});
        Object.keys(extras).forEach(function (key) {
          return scope.setExtra(key, extras[key]);
        });
        scope.setFingerprint([process.env.NODE_ENV, errorType, errObj && errObj.message]);

        if (type === 8) {
          scope.setLevel("info");
        }

        Sentry.captureException(errObj);
      });
    }
  } catch (err) {
    console.warn(err);
  }
};

exports.default = _default;